import { EventEmitter } from 'events';

/**
 * Casts an array of channels to a single mask
 *
 * @param channels
 * @returns
 */
const cast = (channels: number[]) =>
  channels.reduce((mask, channel) => mask | ((1 << channel) | 0), 0);

export class NodeLayers extends EventEmitter<{
  change: [];
}> {
  public mask: number;
  constructor(...channels: number[]) {
    super();
    this.mask = 0;
    this.enable(...channels);
    this.emit('change');
  }

  set(channel: number) {
    this.mask = ((1 << channel) | 0) >>> 0;
    this.emit('change');
  }

  enable(...channels: number[]) {
    this.mask |= cast(channels);
    this.emit('change');
  }

  enableAll() {
    this.mask = 0xffffffff | 0;
    this.emit('change');
  }

  toggle(...channels: number[]) {
    this.mask ^= cast(channels);
    this.emit('change');
  }

  disable(...channels: number[]) {
    this.mask &= ~cast(channels);
    this.emit('change');
  }

  disableAll() {
    this.mask = 0;
    this.emit('change');
  }

  test(layers: NodeLayers) {
    return (this.mask & layers.mask) !== 0;
  }

  isEnabled(...channels: number[]) {
    const mask = cast(channels);
    return (this.mask & mask) === mask;
  }
}
